<template>
  <div class="report-section-banner page-break-avoid" data-testid="report-section-banner">
    {{ title }}
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
  },
});
</script>

<style scoped lang="scss">
.report-section-banner {
  border-radius: 4px;
  background: rgb(var(--v-theme-primary));
  color: white;
  text-transform: uppercase;
  text-align: center;
  font-size: 14px;
  line-height: 130%;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 8px;
}
</style>
